import { useState } from "react";
import { FileDown, Save } from "lucide-react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { api, formatError } from "@/lib/api";

export const PdfButton = ({ c }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/admin/coaching-checkups/${c.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `anamnesi-${(c.name || "contatto").toLowerCase().replace(/[^a-z0-9]+/g, "-")}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" data-testid={`coaching-pdf-btn-${c.id}`} onClick={download} disabled={busy}
      className="mt-3 inline-flex items-center gap-2 border border-[rgba(152,191,162,0.35)] px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#c4dcca] transition-colors hover:border-[#98bfa2] hover:bg-[#98bfa2] hover:text-[#050807] disabled:opacity-50">
      <FileDown size={14} /> {busy ? "Preparo…" : "Scarica PDF"}
    </button>
  );
};

export const CoachNotes = ({ c, onSave }) => {
  const [text, setText] = useState(c.coach_notes || "");
  const [saving, setSaving] = useState(false);
  const dirty = text !== (c.coach_notes || "");
  const save = async () => {
    setSaving(true);
    await onSave(c, { coach_notes: text });
    setSaving(false);
  };
  return (
    <div className="mt-4" data-testid={`coaching-notes-${c.id}`}>
      <p className="mb-2 font-mono text-[11px] uppercase tracking-widest text-[#98bfa2]">Note del trainer</p>
      <Textarea data-testid={`coaching-notes-input-${c.id}`} rows={3} maxLength={5000} value={text} onChange={(e) => setText(e.target.value)}
        placeholder="Cosa vi siete detti al telefono, prossimi passi…" className="text-sm" />
      <div className="mt-2 flex items-center justify-between gap-3">
        <span className="font-mono text-[11px] text-[#a3b1aa]">{c.notes_updated_at ? `Aggiornate il ${new Date(c.notes_updated_at).toLocaleString("it-IT")}` : ""}</span>
        <button type="button" data-testid={`coaching-notes-save-${c.id}`} onClick={save} disabled={!dirty || saving}
          className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap bg-[#98bfa2] px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-[#050807] hover:bg-[#c4dcca] disabled:opacity-40">
          <Save size={13} /> {saving ? "Salvo…" : "Salva note"}
        </button>
      </div>
    </div>
  );
};
